{
  "brand": "OnBrand Mail",
  "brandTagline": "OnBrand Mail — E-Mail-Signaturen, zentral verwaltet.",
  "language": "Sprache",
  "sampleData": "Beispieldaten",
  "sampleDataHint": "VITE_MOCK_SESSION ist aktiv — alles auf dem Bildschirm sind Testdaten.",
  "toggleColorScheme": "Farbschema umschalten",
  "switchToLight": "Zum hellen Modus wechseln",
  "switchToDark": "Zum dunklen Modus wechseln",
  "accountMenu": "Kontomenü",
  "signOut": "Abmelden",
  "signIn": "Anmelden",
  "retry": "Erneut versuchen",
  "loading": "Wird geladen…",
  "save": "Speichern",
  "cancel": "Abbrechen",
  "delete": "Löschen",
  "edit": "Bearbeiten",
  "create": "Erstellen",
  "search": "Suchen",
  "back": "Zurück",
  "next": "Weiter",
  "close": "Schließen",
  "yes": "Ja",
  "no": "Nein",
  "unknownError": "Unbekannter Fehler.",
  "apiUnreachableTitle": "Das Portal konnte die API nicht erreichen",
  "apiUnreachableHint": "In der Entwicklung läuft die API auf Port 5138 und Vite proxyt dorthin. Prüfen Sie, ob sie läuft.",
  "signInMicrosoftGoogle": "OnBrand Mail verwendet Ihr Microsoft- oder Google-Arbeitskonto.",
  "signInGoogle": "OnBrand Mail verwendet Ihr Google-Workspace-Konto.",
  "signInMicrosoft": "OnBrand Mail verwendet Ihr Microsoft-Arbeitskonto.",
  "continueMicrosoft": "Mit Microsoft fortfahren",
  "continueGoogle": "Mit Google fortfahren",
  "noSignInTitle": "Anmeldung nicht konfiguriert",
  "noSignInBody": "Diese Umgebung hat noch keinen Identitätsanbieter. Ein Administrator muss einen einrichten, bevor sich jemand anmelden kann.",
  "accessNotGrantedTitle": "Zugriff noch nicht erteilt",
  "accessNotGrantedBody": "Sie sind als {{email}} angemeldet, aber diesem Konto wurde noch keine Rolle zugewiesen. Ein Administrator muss Ihnen Zugriff gewähren, bevor etwas sichtbar wird.",
  "tryAgain": "Erneut versuchen",
  "backToTenant": "Zurück zum Mandanten",
  "manage": "Verwalten",
  "never": "Nie",
  "unknown": "Unbekannt",
  "copy": "Kopieren",
  "copied": "Kopiert",
  "refresh": "Aktualisieren",
  "continue": "Weiter",
  "confirm": "Bestätigen",
  "remove": "Entfernen",
  "add": "Hinzufügen",
  "open": "Öffnen",
  "download": "Herunterladen",
  "upload": "Hochladen",
  "settings": "Einstellungen",
  "actions": "Aktionen",
  "status": "Status",
  "name": "Name",
  "email": "E-Mail",
  "description": "Beschreibung",
  "enabled": "Aktiviert",
  "disabled": "Deaktiviert",
  "active": "Aktiv",
  "inactive": "Inaktiv",
  "none": "Keine",
  "all": "Alle",
  "optional": "Optional",
  "required": "Erforderlich",
  "any": "Beliebig",
  "done": "Fertig",
  "reason": "Grund",
  "age": {
    "unknown": "zu einem unbekannten Zeitpunkt",
    "justNow": "gerade eben",
    "minutesAgo": "vor {{count}} Minuten",
    "oneHourAgo": "vor 1 Stunde",
    "hoursAgo": "vor {{count}} Stunden",
    "oneDayAgo": "vor 1 Tag",
    "daysAgo": "vor {{count}} Tagen"
  }
}
